var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlightArrival = function SvgFlightArrival(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.69 12.07a2 2 0 0 1-1.41-2.45l1.16-4.34a1.13 1.13 0 0 1 2.19 0l.66 2.55 3.15.84L10 2.83a1.58 1.58 0 0 1 3.07.08l1.56 7.42 4.25 1.14a2.49 2.49 0 0 1 1.87 2.77 2.37 2.37 0 0 1-3 1.87z"
  })));
};
export default SvgFlightArrival;